import React, {useEffect, useImperativeHandle, useCallback, useMemo} from 'react';
import imageCompression from 'browser-image-compression';
import {isMobile} from 'react-device-detect';
import {useHistory} from 'react-router-dom';
import {Form, FormGroup} from 'reactstrap';
import {useFormik} from 'formik';
import * as Yup from 'yup';

import {isEmptyObject} from '../../../../helpers';
import {Camera} from '../../../../components/molecules';
import {strings} from '../../../../assets';

const CALLER = 'FOTO';

const INITIAL_VALUES = {
  bike_direira: '',
  bike_esquerda: '',
  grupo: '',
  roda_dianteira: '',
  roda_traseira: '',
  frontal: '',
  cambio_dianteiro: '',
  cambio_traseiro: '',

  numero_serie: '',
  nota_fiscal: '',
  opcional: '',
};

const INITIAL_VALUES_MODAL = {
  right_side: '',
  left_side: '',

  numero_serie: '',
  nota_fiscal: '',
  opcional: '',
};

const Foto = ({position, current, checkAdvance, extraData, sucessFoto, corPrimaria}) => {
  useImperativeHandle(ref, () => ({
    values: () => {
      const newV = {...values};
      return {caller: CALLER, data: {fotos: newV}};
    },
  }));
  const history = useHistory();

  const isModal = extraData.segurado.segurado_bicicletas[0].modalidade_bicicleta.id <= 5 ? false : true;

  const {setFieldValue, resetForm, errors, values} = useFormik({
    initialValues: isModal ? INITIAL_VALUES_MODAL : INITIAL_VALUES,
    validationSchema: isModal ? validationSchemaEquipment : validationSchemaBike,
    initialErrors: strings.INITIAL_ERRORS,
  });

  const setFoto = useCallback(
    (field) => async (value) => {
      if (value.type !== 'application/pdf') {
        value = await imageCompression(value, {maxSizeMB: 0.5});
      }

      setFieldValue(field, value, true);
    },
    [setFieldValue],
  );

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  }, [checkAdvance, current, errors, position]);

  useEffect(() => {
    if (!isMobile) history.replace('corretor/erro');
  }, [history]);

  useEffect(() => {
    if (current === position) window.scrollTo({top: 0});
  }, [current, position]);

  useEffect(() => {
    resetForm();
  }, [sucessFoto]);

  const Fields = useMemo(
    () => (
      <Form className="mt-4">
        <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Capture fotos do produto</h1>

        <p>
          {isModal
            ? 'Para finalização do seu processo de contração e envio para análise da Seguradora, precisamos que fotografe seu equipamento de acordo com os ângulos abaixo indicados e que também envie a Nota Fiscal de seu equipamento.'
            : 'Para finalização do seu processo de contração e envio para análise da Seguradora, precisamos que fotografe sua bicicleta de acordo com os ângulos abaixo indicados e que também envie a Nota Fiscal de Sua bicicleta.'}
        </p>

        {isModal ? (
          <>
            <FormGroup>
              <Camera
                icon={extraData.segurado.id_projeto === 6 ? 'rightScooterSide' : 'rightSide'}
                title="Foto do equipamento inteiro lado direito"
                onPhotoTaken={setFoto('right_side')}
              />
            </FormGroup>

            <FormGroup>
              <Camera
                icon={extraData.segurado.id_projeto === 6 ? 'leftScooterSide' : 'leftSide'}
                title="Foto do equipamento inteiro lado esquerdo"
                onPhotoTaken={setFoto('left_side')}
              />
            </FormGroup>
          </>
        ) : (
          <>
            <FormGroup>
              <Camera
                icon="bike"
                title="Foto da sua bicicleta (inteira do lado direito)"
                onPhotoTaken={setFoto('bike_direira')}
              />
            </FormGroup>

            {extraData.segurado.id_projeto !== 5 && (
              <FormGroup>
                <Camera
                  icon="bike_esquerda"
                  title="Foto da sua bicicleta (inteira do lado esquerdo)"
                  onPhotoTaken={setFoto('bike_esquerda')}
                />
              </FormGroup>
            )}

            <FormGroup>
              <Camera icon="bike_group" title="Foto do grupo" onPhotoTaken={setFoto('grupo')} />
            </FormGroup>

            {extraData.segurado.id_projeto !== 5 && (
              <>
                <FormGroup>
                  <Camera icon="front_wheel" title="Roda dianteira" onPhotoTaken={setFoto('roda_dianteira')} />
                </FormGroup>
                <FormGroup>
                  <Camera icon="back_wheel" title="Roda traseira" onPhotoTaken={setFoto('roda_traseira')} />
                </FormGroup>
                <FormGroup>
                  <Camera icon="front_bike" title="Foto frontal" onPhotoTaken={setFoto('frontal')} />
                </FormGroup>
                <FormGroup>
                  <Camera icon="front_shift" title="Câmbio dianteiro" onPhotoTaken={setFoto('cambio_dianteiro')} />
                </FormGroup>
                <FormGroup>
                  <Camera icon="back_shift" title="Câmbio traseiro" onPhotoTaken={setFoto('cambio_traseiro')} />
                </FormGroup>
              </>
            )}
          </>
        )}

        <FormGroup>
          <Camera icon="bar_code" title="Foto do número de série" onPhotoTaken={setFoto('numero_serie')} />
        </FormGroup>

        <FormGroup>
          <Camera icon="bill" title="Foto da nota fiscal" onPhotoTaken={setFoto('nota_fiscal')} pdf capture={null} />
        </FormGroup>

        <FormGroup>
          <Camera icon="bill" title="Outra foto (opcional)" onPhotoTaken={setFoto('opcional')} />
        </FormGroup>
      </Form>
    ),
    [isModal, setFoto],
  );

  return <>{current === position && Fields}</>;
};

const validationSchemaBike = Yup.object().shape({
  bike_direira: Yup.string().min(1).required(strings.required),
  grupo: Yup.string().min(1).required(strings.required),
  numero_serie: Yup.string().min(1).required(strings.required),
  nota_fiscal: Yup.string().min(1).required(strings.required),
  opcional: Yup.string(),
});

const validationSchemaEquipment = Yup.object().shape({});

export default React.memo(Foto);
export const ref = React.createRef();
